import React, { useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'
import { store } from '@/store/index'
import { validLicenseSettings } from './utils/api.js'
import router from './routes/app.js'
import { Enums, Categories, Settings } from './utils/settings.js'
import { getEnums, getCategories, getProfile } from './api/judge.js'
import RouterGuard from '@/components/RouterGuard/index.jsx'
import useToken from './utils/useToken.js'

validLicenseSettings()

function App() {
  const { getToken } = useToken()

  useEffect(() => {
    try {
      getEnums().then((res) => {
        for (let [key, value] of Object.entries(res)) {
          Enums[key] = value
        }
      })
      getCategories({ filter: { type: 'events' }}).then(res => {
        Categories.events = res.list
      })
    } catch (e) {
      //
    }

    if (getToken()) {
      getProfile().then((res) => {
        Settings.profile = res
        store.dispatch({
          type: 'set_profile',
          payload: res
        })
      })
    }
  }, [])

  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <RouterGuard>
        <RouterProvider router={router} />
      </RouterGuard>
    </React.Suspense>
  )
}

export default App
